import api from './api';

export const registerUser = async (userData) => {
  const response = await api.post('/auth/register', userData);
  // El backend devuelve { accessToken, user, message }
  return response.data;
};

export const loginUser = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  // El backend devuelve { accessToken, user }
  return response.data;
};

export const logoutUser = async () => {
  // Se envía una petición POST para que el backend invalide la cookie del refreshToken.
  const response = await api.post('/auth/logout');
  return response.data;
};

export const verifyCurrentSession = async () => {
  // Se envía una petición POST. El navegador adjuntará la cookie httpOnly automáticamente.
  // El backend la usará para verificar la sesión y devolver un nuevo accessToken.
  return api.post('/auth/session');
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const checkAvailability = async (field, value) => {
  try {
    const response = await api.get('/auth/check-availability', {
      params: { field, value },
    });
    return response.data.exists;
  } catch (error) {
    console.error(`Error al verificar ${field}:`, error);
    throw new Error(`Error al verificar la disponibilidad de ${field}.`);
  }
};

export const verifyEmailToken = async (token) => {
  try {
    const { data } = await api.get(`/auth/verify-email/${token}`);
    return data;
  } catch (error) {
    console.error(
      'Error verifying email token:',
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteCurrentUserAccount = async (payload) => {
  try {
    const response = await api.delete('/users/me', { data: payload });
    return response.data;
  } catch (error) {
    console.error(
      'Error en deleteCurrentUserAccount:',
      error.response?.data || error.message
    );
    throw error;
  }
};
